import React from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

interface PageWrapperProps {
  children: React.ReactNode;
  withSearchBar?: boolean;
  fullWidth?: boolean;
  className?: string;
  extraTopPadding?: number;
}

const PageWrapper: React.FC<PageWrapperProps> = ({ 
  children, 
  withSearchBar = false,
  fullWidth = false,
  className = '',
  extraTopPadding = 0
}) => {
  const location = useLocation();
  
  // Calculate dynamic top padding based on various factors
  const getTopPadding = () => {
    const basePadding = withSearchBar ? 'pt-36' : 'pt-24';
    
    // Add more padding for specific routes that need extra space
    if (location.pathname === '/refer' || 
        location.pathname === '/pricing' || 
        location.pathname === '/faq' ||
        location.pathname.startsWith('/property/')) {
      return 'pt-32';
    }
    
    // Add custom extra padding if specified
    if (extraTopPadding) {
      return `pt-${extraTopPadding}`;
    }
    
    return basePadding;
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className={`min-h-screen bg-gray-50 ${getTopPadding()} ${className}`}
    >
      <main className={`${fullWidth ? 'w-full' : 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'}`}>
        {children}
      </main>
    </motion.div>
  );
};

export default PageWrapper;